import styled from "styled-components";
import Image from "../../../../assets/section2.svg";
const Shield = () => {
  return (
    <Container>
      <Wrapper>
        <div>
          <ShieldImage>
            <img src={Image} alt="bannerImage" />
          </ShieldImage>
          <div>
            <h1>A shield you can trust</h1>
            <TextPara>
              When life shoots arrows of lack, want, insufficiency, business
              frustration, limited opportunities and stress,{" "}
              <span className="company__name">INVEST-TRUST </span>shields you
              from being hit. We are the shield you can absolutely rely on.
            </TextPara>
          </div>
        </div>
      </Wrapper>
    </Container>
  );
};

export default Shield;

export const Container = styled.div`
    background-image: url('https://res.cloudinary.com/dvwbbiu0g/image/upload/v1652293811/invest-trust-business/section_b_mkwldx.png');
    // background-position: center;
    //  background-repeat: no-repeat;
    margin-top: 5rem;

     @media screen and (max-width: 991px) {
        width: 100vw;
    }
    @media screen and (max-width: 579px) {
    }
  }
`;

export const Wrapper = styled.div`
  max-width: 1440px;
  margin: auto;

  .company__name {
    font-weight: 700;
  }

  div:nth-of-type(1) {
    margin-left: 5rem;
    margin-right: 5rem;
    height: 804px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 10rem;

    @media screen and (max-width: 991px) {
      height: auto;
      display: flex;
      flex-direction: column;
      //   justify-content: flex-start;
      gap: 1rem;
    }
    @media screen and (max-width: 579px) {
      margin-left: 2rem;
      margin-right: 2rem;
    }
  }

  div h1 {
    font-family: "Futura";
    line-height: 56px;
    font-size: 3rem;
    color: ${({ theme }) => theme.colors.text};

    @media screen and (max-width: 991px) {
      font-size: 2.5rem;
      text-align: center;
    }
    @media screen and (max-width: 579px) {
      font-size: 2.5rem;
      width: 100%;
    }
  }

  div p:nth-of-type(1) {
  }
  @media screen and (max-width: 991px) {
    margin-left: 2rem;
    margin-right: 2rem;
    text-align: center;
  }
  @media screen and (max-width: 579px) {
    margin-left: 1rem;
    margin-right: 1rem;
    text-align: center;
  }
  @media screen and (max-width: 479px) {
    margin-left: 0rem;
    margin-right: 0rem;
    text-align: center;
  }
`;

export const ShieldImage = styled.div`
  width: 100%;

  img {
    width: 100%;
  }

  @media screen and (max-width: 579px) {
    margin-top: 10rem;
    width: 150%;
  }
  @media screen and (max-width: 479px) {
    margin-top: 2rem;
    width: 100%;
    img {
      //
      width: 120%;
    }
  }
`;

export const TextPara = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.text};

  @media screen and (max-width: 991px) {
    text-align: center;
  }
  @media screen and (max-width: 579px) {
    margin-left: 0rem;
    margin-right: 0rem;
    width: 100%;
    font-size: 1rem;
    // padding-left: 2rem;
    padding-bottom: 2rem;
  }
`;
